import { Injectable } from '@angular/core';

/**
 * * Serviço para componentes com paginação.
 */
@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  constructor() { }

  /**
   * * Página (modal).
   */
  public page:number = 1;
  /**
   * * Tamanho de página (modal).
   */
  public pageSize:number = 20;
  /**
   * * Número total de registros (modal).
   */
  public collectionSize:number = 0;
  /**
   * * Total de páginas (modal).
   */
  public allPages:number = 1;

  // * PARA USAR EM MODAIS COM PAGINAÇÃO

  // * Evita bug quando o modal abre sobre uma tela que também é paginada

  /**
   * * Página (modal).
   */
  public modalPage:number = 1;
  /**
   * * Tamanho de página (modal).
   */
  public modalPageSize:number = 20;
  /**
   * * Número total de registros (modal).
   */
  public modalCollectionSize:number = 0;
  /**
   * * Total de páginas (modal).
   */
  public modalAllPages:number = 1;
}
